import React from 'react';
import { observer } from 'mobx-react';

import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Form } from 'libs/forms/index';
import { Trans } from 'react-i18next';

import { CollectionFormAppManager } from 'apps/collection/collectionForm/appManager';

@observer
export class CollectionForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new CollectionFormAppManager(null, modalStore.props);
  }

  render() {
    const { collectionFormApp } = this.appManager;
    const { form } = collectionFormApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={collectionFormApp.SubmitCollection}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
